const protectedContactFormSelector = '.js-contact-form';
const honeypotSelector = '[data-contact-honeypot]';

document.addEventListener(
  'submit',
  (event) => {
    const form = event.target;

    if (!(form instanceof HTMLFormElement) || !form.matches(protectedContactFormSelector)) {
      return;
    }

    const honeypot = form.querySelector(honeypotSelector);

    if (honeypot instanceof HTMLInputElement && honeypot.value.trim() !== '') {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  },
  true
);
